// services/address/countryConfig.js
export const COUNTRIES = {
    IT: {
        code: 'IT',
        name: 'Italia',
        flag: '🇮🇹',
        locale: 'it-IT',
        
        // SOLO campi di indirizzo (nessun campo fiscale)
        fields: [
            { name: 'nome', type: 'text', required: true, label: 'Nome', maxLength: 100 },
            { name: 'cognome', type: 'text', required: true, label: 'Cognome', maxLength: 100 },
            { name: 'azienda', type: 'text', required: false, label: 'Azienda', maxLength: 255 },
            { name: 'indirizzo', type: 'text', required: true, label: 'Indirizzo', placeholder: 'Via, Piazza, numero civico' },
            { name: 'indirizzo2', type: 'text', required: false, label: 'Altro indirizzo', placeholder: 'Scala, piano, interno' },
            { name: 'citta', type: 'text', required: true, label: 'Città' },
            { name: 'provincia', type: 'select', required: true, label: 'Provincia', source: 'italy' },
            { name: 'cap', type: 'text', required: true, label: 'CAP', pattern: '\\d{5}', hint: '5 cifre' },
            { name: 'telefono', type: 'tel', required: true, label: 'Telefono' }
        ],
        
        fieldOrder: ['nome', 'cognome', 'azienda', 'indirizzo', 'indirizzo2', 'citta', 'provincia', 'cap', 'telefono', 'email'],
        
        validators: {
            cap: (value) => /^\d{5}$/.test(value),
            telefono: (value) => /^[\d\s+\-()]{8,20}$/.test(value)
        },
        
        addressFormat: '{nome} {cognome}\n{azienda}\n{indirizzo}\n{cap} {citta} {provincia}'
    },
    
    FR: {
        code: 'FR',
        name: 'France',
        flag: '🇫🇷',
        locale: 'fr-FR',
        
        fields: [
            { name: 'nom', type: 'text', required: true, label: 'Nom', maxLength: 100 },
            { name: 'prenom', type: 'text', required: true, label: 'Prénom', maxLength: 100 },
            { name: 'entreprise', type: 'text', required: false, label: 'Entreprise', maxLength: 255 },
            { name: 'adresse', type: 'text', required: true, label: 'Adresse', placeholder: 'Numéro et rue' },
            { name: 'adresse2', type: 'text', required: false, label: 'Complément', placeholder: 'Bâtiment, étage' },
            { name: 'ville', type: 'text', required: true, label: 'Ville' },
            { name: 'codePostal', type: 'text', required: true, label: 'Code Postal', pattern: '\\d{5}', hint: '5 chiffres' },
            { name: 'telephone', type: 'tel', required: true, label: 'Téléphone' }
        ],
        
        fieldOrder: ['nom', 'prenom', 'entreprise', 'adresse', 'adresse2', 'ville', 'codePostal', 'telephone', 'email'],
        
        validators: {
            codePostal: (value) => /^\d{5}$/.test(value),
            telephone: (value) => /^[\d\s+\-()]{8,20}$/.test(value)
        },
        
        addressFormat: '{prenom} {nom}\n{entreprise}\n{adresse}\n{codePostal} {ville}'
    },
    
    ES: {
        code: 'ES',
        name: 'España',
        flag: '🇪🇸',
        locale: 'es-ES',
        
        fields: [
            { name: 'nombre', type: 'text', required: true, label: 'Nombre', maxLength: 100 },
            { name: 'apellido', type: 'text', required: true, label: 'Apellido', maxLength: 100 },
            { name: 'empresa', type: 'text', required: false, label: 'Empresa', maxLength: 255 },
            { name: 'direccion', type: 'text', required: true, label: 'Dirección', placeholder: 'Calle, número' },
            { name: 'direccion2', type: 'text', required: false, label: 'Piso, puerta' },
            { name: 'ciudad', type: 'text', required: true, label: 'Ciudad' },
            { name: 'provincia', type: 'select', required: true, label: 'Provincia', source: 'spain' },
            { name: 'codigoPostal', type: 'text', required: true, label: 'Código Postal', pattern: '\\d{5}', hint: '5 dígitos' },
            { name: 'telefono', type: 'tel', required: true, label: 'Teléfono' }
        ],
        
        fieldOrder: ['nombre', 'apellido', 'empresa', 'direccion', 'direccion2', 'ciudad', 'provincia', 'codigoPostal', 'telefono', 'email'],
        
        validators: {
            codigoPostal: (value) => /^\d{5}$/.test(value),
            telefono: (value) => /^[\d\s+\-()]{8,20}$/.test(value)
        },
        
        addressFormat: '{nombre} {apellido}\n{empresa}\n{direccion}\n{codigoPostal} {ciudad} {provincia}'
    },
    
    PT: {
        code: 'PT',
        name: 'Portugal',
        flag: '🇵🇹',
        locale: 'pt-PT',
        
        fields: [
            { name: 'nome', type: 'text', required: true, label: 'Nome', maxLength: 100 },
            { name: 'apelido', type: 'text', required: true, label: 'Apelido', maxLength: 100 },
            { name: 'empresa', type: 'text', required: false, label: 'Empresa', maxLength: 255 },
            { name: 'morada', type: 'text', required: true, label: 'Morada', placeholder: 'Rua, número' },
            { name: 'morada2', type: 'text', required: false, label: 'Complemento' },
            { name: 'cidade', type: 'text', required: true, label: 'Cidade' },
            { name: 'codigoPostal', type: 'text', required: true, label: 'Código Postal', pattern: '\\d{4}-\\d{3}', hint: 'XXXX-XXX' },
            { name: 'telefone', type: 'tel', required: true, label: 'Telefone' }
        ],
        
        fieldOrder: ['nome', 'apelido', 'empresa', 'morada', 'morada2', 'cidade', 'codigoPostal', 'telefone', 'email'],
        
        validators: {
            codigoPostal: (value) => /^\d{4}-\d{3}$/.test(value),
            telefone: (value) => /^[\d\s+\-()]{8,20}$/.test(value)
        },
        
        addressFormat: '{nome} {apelido}\n{empresa}\n{morada}\n{codigoPostal} {cidade}'
    }
};

// Lista paesi per il selector
export const COUNTRY_LIST = Object.values(COUNTRIES).map(({ code, name, flag }) => ({
    code,
    name,
    flag
}));

// Helper per ottenere configurazione paese
export const getCountryConfig = (countryCode) => {
    return COUNTRIES[countryCode] || COUNTRIES.IT;
};
